// Generated by purs version 0.13.8
"use strict";
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var dreamer = "https://cdn.discordapp.com/attachments/672889285438865453/708301925510283264/undraw_dreamer_gxxi.png";
var error = function (text) {
    return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("error-container") ])([ Halogen_HTML_Elements.img([ Halogen_HTML_Properties.src(dreamer), Halogen_HTML_Properties.alt("error"), Lunarbox_Component_Utils.className("error-illustration") ]), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("error-text") ])([ Halogen_HTML_Core.text(text) ]) ]);
};
module.exports = {
    error: error
};
